import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=639a9489&scoped=true&"
import script from "./Lottie.vue?vue&type=script&lang=js&"
export * from "./Lottie.vue?vue&type=script&lang=js&"
import style0 from "./Lottie.vue?vue&type=style&index=0&id=639a9489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a9489",
  null
  
)

export default component.exports